module.exports = __webpack_public_path__ + "static/aloopdatepicker-a086d81119257f41fe51a7e41f052c7c.png";